import { isStockLine } from '@onward-delivery/core';
import { colors } from '@/styles';
import { getItemPalletId } from '@/utilities/manifestPallets';

export const isUnallocatedForwardStocked = (order) => order?.forward_stocked_status != null;

// A stock line is a placeholder until a pick puts a pallet on it, whether or not it carries a serial yet.
export const isPlaceholderItem = (item, order) => !!item?.item_id && isStockLine(item, order) && !getItemPalletId(item);

export const PLACEHOLDER_ITEM_TOOLTIP =
    'Placeholder for a forward-stocked unit. It is replaced with a real unit when the warehouse allocates this order by scanning in the mobile app.';

export const PLACEHOLDER_ITEM_STATUS = {
    label: 'Placeholder',
    color: colors.greys.primary,
    title: PLACEHOLDER_ITEM_TOOLTIP,
};

const FORWARD_STOCKING_TAGS = {
    INVENTORY: {
        key: 'INVENTORY',
        label: 'Forward Stock Inventory',
        shortLabel: 'FS Inventory',
        color: colors.blues.primary,
        tooltip:
            'Inventory-only order. These units are held in the warehouse as forward stock and leave later on a separate delivery order.',
    },
    UNALLOCATED: {
        key: 'UNALLOCATED',
        label: 'Unallocated Forward Stock',
        shortLabel: 'Unallocated FS',
        color: colors.oranges.primary,
        tooltip:
            'Delivery from forward-stocked inventory. Its items are placeholders until real units are allocated by scanning them during warehousing picking. Never add it to an inbound manifest: the real units were already received on the inventory order.',
    },
    ALLOCATED: {
        key: 'ALLOCATED',
        label: 'Forward Stock Delivery',
        shortLabel: 'FS Delivery',
        color: colors.greys.primary,
        tooltip: 'Delivery order filled from forward-stocked inventory.',
    },
};

export const getForwardStockingTag = (order) => {
    if (order?.order_type === 'wh_inventory') return FORWARD_STOCKING_TAGS.INVENTORY;
    return FORWARD_STOCKING_TAGS[order?.forward_stocked_status] || null;
};
